export default __webpack_public_path__ + "6ed93aae5268f736a47ddda56a9d4cd7.png";